import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import axios from "axios";
import { flashDispatch, flashMessage } from "@/shared/helpers";
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage";
import { sendFlashMessage } from "@/redux/actions/flashActions";

const LockParticipantModal = ({
  isOpen, setOpen, toggle, participants, program, organization, setRefreshUsers
}) => {
  const dispatch = flashDispatch();

  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);

  // Reset on open
  useEffect(() => {
    if (isOpen) {
      setReason("");
      setError("");
      setShowConfirm(false);
      setSaving(false);
    }
  }, [isOpen]);

  // ---------- Step 1: Validate & ask confirm ----------
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      setError("Reason is required");
      return;
    }

    setError("");
    setShowConfirm(true);
  };

  // ---------- Step 2: API call ----------
 const handleConfirmLock = () => {
  setSaving(true);
const participant = Array.isArray(participants) ? participants[0] : participants;
  axios
    .put(
      `/organization/${program.organization_id}/program/${program.id}/user/${participant.id}/lockaccount`,
      { reason }
    )
    .then((res) => {
      if (res.status === 200) {
        dispatch(flashMessage("Participant account locked successfully!"));
        setRefreshUsers(true);
        setShowConfirm(false);
        toggle();
      }
    })
    .catch((error) => {
      if (error?.response?.data) {
        dispatch(
          sendFlashMessage(
            <ApiErrorMessage errors={error.response.data} />,
            "alert-danger"
          )
        );
      }
    })
    .finally(() => {
      setSaving(false);
    });
};


  return (
    <>
      {/* ================= MAIN FORM MODAL ================= */}

      <Modal
        isOpen={isOpen}
        toggle={toggle}
        style={{ zIndex: 1000 }}
      >
        <ModalHeader toggle={toggle} className="text-danger">
          Lock User Account
        </ModalHeader>

        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label for="reason_to_lock">
                Reason to Lock Account *
              </Label>

              <Input
                type="textarea"
                id="reason_to_lock"
                rows="4"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter reason for locking this account"
                invalid={!!error}
              />

              {error && <FormFeedback>{error}</FormFeedback>}
            </FormGroup>
          </ModalBody>

          <ModalFooter>
            <Button
              color="secondary"
              type="button"
              onClick={toggle}
              disabled={saving}
            >
              Cancel
            </Button>

            <Button
              color="danger"
              type="submit"
              disabled={saving}
            >
              Lock Account
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* ================= CONFIRM MODAL ================= */}

      <Modal
        isOpen={showConfirm}
        toggle={() => setShowConfirm(false)}
        backdrop="static"
        style={{ zIndex: 2000 }}
      >
        <ModalHeader toggle={() => setShowConfirm(false)}>
          Confirm Account Lock
        </ModalHeader>

        <ModalBody>
          <p>You are about to lock this participant’s account.</p>

          <p className="text-danger fw-bold">
            Once locked, you will NOT be able to unlock the account yourself and will
            have to contact support to unlock the account.
          </p>
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            type="button"
            onClick={() => setShowConfirm(false)}
            disabled={saving}
          >
            Cancel
          </Button>

          <Button
            color="danger"
            type="button"
            onClick={handleConfirmLock}
            disabled={saving}
          >
            {saving ? "Locking..." : "Yes, Lock Account"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LockParticipantModal;
